import { computed, ref, toValue, watch } from "vue";
import { useIntervalFn } from "@vueuse/core";
const HEARTBEAT_MS = 1e4;
export const presenceColor = (id) => {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1)
    hash = hash * 31 + id.charCodeAt(i) | 0;
  return `hsl(${(hash >>> 0) % 360} 70% 50%)`;
};
const toLoroRecord = (obj) => {
  const result = {};
  for (const [key, value] of Object.entries(obj))
    if (value !== void 0) result[key] = value;
  return result;
};
const isPresenceData = (data) => typeof data === "object" && data !== null && typeof data.name === "string" && typeof data.color === "string";
export const usePresenceIdentity = (collab, identity, options = {}) => {
  const extra = ref({});
  const identityProfile = computed(() => {
    const id = toValue(identity);
    return {
      name: id.name?.trim() || id.id,
      picture: id.picture,
      user: id.user,
      color: presenceColor(id.id)
    };
  });
  const profile = computed(() => ({
    ...identityProfile.value,
    ...extra.value
  }));
  const broadcast = () => {
    if (collab.status.value !== "open") return;
    collab.presence.setLocal(toLoroRecord(profile.value));
  };
  const update = (patch) => {
    extra.value = { ...extra.value, ...patch };
    broadcast();
  };
  const heartbeatMs = options.heartbeatMs != null && Number.isFinite(options.heartbeatMs) && options.heartbeatMs > 0 ? options.heartbeatMs : HEARTBEAT_MS;
  const heartbeat = useIntervalFn(broadcast, heartbeatMs, { immediate: false });
  watch(
    () => collab.status.value,
    (status) => {
      if (status === "open") {
        broadcast();
        heartbeat.resume();
      } else {
        heartbeat.pause();
      }
    },
    { immediate: true }
  );
  watch(identityProfile, broadcast);
  const peers = computed(() => {
    const ownId = toValue(identity).id;
    return Object.entries(collab.presence.peers.value).filter(([id, data]) => id !== ownId && isPresenceData(data)).map(([id, data]) => ({ id, ...data }));
  });
  return { peers, update, broadcast };
};
